import { useEffect, useState } from 'react';
import Menu from './Header/Menu';
import Content from './Main/Content';
import AccessNav from './AccessibilityNav/AccessNav';
import { useVersionControlStore } from '../@iosper/components/VersionControl/store/hooks';
import Mantenimiento from './Messages/Page/Mantenimiento';
import SnackbarMessages from './Messages/SnackbarMessages';

const Layouts = () => {
  const { state, dispatchCheckVersion } = useVersionControlStore();
  const [isUpdated, setIsUpdated] = useState(true);

  useEffect(() => {
    dispatchCheckVersion();
  }, []);

  useEffect(() => {
    setIsUpdated(state.isUptodate);
  }, [state]);

  return (
    <>
      {!isUpdated && <Mantenimiento />}

      {isUpdated && (
        <>
          <header>
            <AccessNav />
          </header>
          <Menu>
            <Content />
          </Menu>
          <SnackbarMessages />
        </>
      )}
    </>
  );
};

export default Layouts;
